module.exports = __webpack_public_path__ + "img/google-play-ko.a6527b06.png";